import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AppCommonRoutingModule } from "./app-common-routing.module";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { LayoutComponent } from "./layout/layout.component";
import { UtilsModule } from "../utils/utils.module";
import { LoginComponent } from './login/login.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppCommonService } from './app-common.service';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSnackBarModule } from "@angular/material/snack-bar";
@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    LayoutComponent,
    LoginComponent,
    ForgotpasswordComponent,
    ChangepasswordComponent,
  ],
  providers: [AppCommonService],
  imports: [CommonModule, AppCommonRoutingModule, UtilsModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, UtilsModule, MatSnackBarModule
  ]
})
export class AppCommonModule { }
